module.exports = __webpack_public_path__ + "static/media/users.f0052dd4.svg";